document.addEventListener('DOMContentLoaded', () => {
  class ProductGalleryNavigation extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector('scroll-carousel');
      this.prevButton = this.querySelector('carousel-prev-button button');
      this.nextButton = this.querySelector('carousel-next-button button');
      
      // Initialize navigation
      this.setupNavigation();
    }

    setupNavigation() {
      // Add click event listeners to navigation buttons
      this.prevButton?.addEventListener('click', () => this.navigatePrevious());
      this.nextButton?.addEventListener('click', () => this.navigateNext());
    }

    navigatePrevious() {
      const visibleMedia = Array.from(this.carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
      const currentIndex = visibleMedia.findIndex(media => media.classList.contains('is-initial'));
      
      if (currentIndex > 0) {
        const previousMedia = visibleMedia[currentIndex - 1];
        this.scrollToMedia(previousMedia);
      }
    }

    navigateNext() {
      const visibleMedia = Array.from(this.carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
      const currentIndex = visibleMedia.findIndex(media => media.classList.contains('is-initial'));
      
      if (currentIndex < visibleMedia.length - 1) {
        const nextMedia = visibleMedia[currentIndex + 1];
        this.scrollToMedia(nextMedia);
      }
    }

    scrollToMedia(mediaElement) {
      // Remove 'is-initial' class from current media
      this.carousel.querySelector('.product-gallery__media.is-initial')?.classList.remove('is-initial');
      
      // Add 'is-initial' class to new media
      mediaElement.classList.add('is-initial');
      
      // Scroll to the media element
      mediaElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest', 
        inline: 'center' 
      });

      // Update thumbnail selection
      this.updateThumbnails(mediaElement);
    }

    updateThumbnails(currentMedia) {
      // Update thumbnail active state
      const thumbnails = this.querySelector('product-gallery-navigation');
      if (thumbnails) {
        const thumbnailButtons = thumbnails.querySelectorAll('.product-gallery__thumbnail');
        thumbnailButtons.forEach(button => {
          const isCurrentMedia = button.dataset.mediaId === currentMedia.dataset.mediaId;
          button.setAttribute('aria-current', isCurrentMedia);
        });
      }
    }
  }

  // Define custom element
 customElements.define('product-gallery', ProductGalleryNavigation);
});